import { genComponentStyleHook, type FullToken } from './styleUtil'
import { background } from './gradientUtil'
import { DOT_PREFIX } from './constant'

export default genComponentStyleHook(['Switch', 'techTheme'], (token: FullToken) => {
  const { componentCls } = token
  return {
    [`${componentCls}${DOT_PREFIX}`]: {
      [`&${componentCls}&${componentCls}-checked`]: {
        '&, &:hover, &:focus': {
          background: `${background} !important`,
        },
      },
    },
  }
})
